import { useNavigate, useLocation } from "react-router-dom";
import * as React from "react";

import { Paper, Typography } from "mpulse-design-system";
import { styled } from "@mui/material";

import { useAuth } from "../../hooks/useAuth";

const LoginForm = ({ setLoginCardState, getLoginCredentials, children }) => {
  const { login } = useAuth();
  const navigate = useNavigate(),
    location = useLocation(),
    history = location.state?.from?.pathname || "";

  const handleLogin = (e) => {
    e.preventDefault();
    const { email, password } = getLoginCredentials();

    if (email && password) {
      setLoginCardState({
        fetchingLogin: true,
        showServerError: false,
        showWrongPasswordError: false,
        showTooManyClientsError: false,
      });
      login(email, password)
        .then((tooManyClients) => {
          if (tooManyClients) {
            // v1 will only support Providence,
            //  so we should only allow access to one client
            setLoginCardState({
              fetchingLogin: false,
              showTooManyClientsError: true,
            });
          } else {
            if (history) {
              navigate(history, { replace: true });
            } else {
              navigate("/dashboard", { replace: true });
            }
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.status === 400 &&
            Array.isArray(error.response.data.non_field_errors)
          ) {
            error.response.data.non_field_errors.forEach((err) => {
              if (err === "Unable to log in with provided credentials.") {
                setLoginCardState({ showWrongPasswordError: true });
              }
            });
          } else {
            setLoginCardState({ showServerError: true });
          }
          setLoginCardState({ fetchingLogin: false });
        });
    }
  };
  return <FormStyled onSubmit={handleLogin}>{children}</FormStyled>;
};

const FormStyled = styled("form")(() => ({
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
}));

export default LoginForm;
